// Etch theme metadata (spec §2.4, §6.1) — exactly three choices: Auto, Paper, Ink.
// Actual colour values live in styles/tokens.css + styles/themes.css, resolved at
// the CSS layer via :root[data-theme]. This module carries no colours of its
// own — only the id/label/preview metadata ThemeSettings needs to render the
// picker. `preview` is a triple of GLOBAL token names (not theme-scoped
// semantic tokens) so a card can show both Paper and Ink swatches regardless
// of which theme is currently active on <html>.
//
// Free custom-color editing is retired (spec §17.5) — there is no colour map
// here to merge/override, and nothing in this file writes to document.style.

export const DEFAULT_THEME = 'auto';

export const THEMES = [
  {
    id: 'auto',
    labelKey: 'settings.theme.auto',
    hintKey: 'settings.theme.autoHint',
    preview: ['--etch-paper-200', '--etch-ink-900', '--etch-red-600'],
  },
  {
    id: 'paper',
    labelKey: 'settings.theme.paper',
    hintKey: 'settings.theme.paperHint',
    preview: ['--etch-paper-200', '--etch-paper-50', '--etch-red-600'],
  },
  {
    id: 'ink',
    labelKey: 'settings.theme.ink',
    hintKey: 'settings.theme.inkHint',
    preview: ['--etch-ink-900', '--etch-ink-800', '--etch-red-600'],
  },
];
